import { ConfirmationModal } from '@/components/modals/ConfirmationModal/ConfirmationModal';
import { useNavigateToRoute } from '@/components/navigation/useNavigateToRoute';
import {
  AssetIntegrationProviders,
  getIntegrationProviderDisplayName,
} from '@/modules/assetProviderIntegrations/shared/constants';
import { getIntegrationLoginPath } from '@/modules/assetProviderIntegrations/shared/utils';
import { ROUTE_KEYS } from '@/navigation/constants';
import { englishJoinStringList } from '@/utils/formatting/strings';

export interface IntegrationConnectionWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  canConnectToIntegrations: AssetIntegrationProviders[];
}

export function IntegrationConnectionWarningModal({
  isOpen,
  onClose,
  canConnectToIntegrations,
}: IntegrationConnectionWarningModalProps) {
  const { navigate } = useNavigateToRoute();

  const connectableIntegrationNames = englishJoinStringList(
    canConnectToIntegrations.map((integration) =>
      getIntegrationProviderDisplayName(integration)
    ),
    'or'
  );

  const handleClose = (reason: 'confirm' | 'cancel') => {
    if (reason === 'cancel') {
      onClose();
      return;
    }

    const integration = canConnectToIntegrations[0];
    if (integration && canConnectToIntegrations.length === 1) {
      const redirectTarget = window.location.href;
      const loginPath = getIntegrationLoginPath(integration, redirectTarget);
      if (loginPath) {
        window.location.href = loginPath;
      }
    } else {
      onClose();
      navigate(ROUTE_KEYS.USER_SETTINGS, {});
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      heading="No integration linked"
      cancelText="Close"
      confirmText="Link account"
      onClose={handleClose}
    >
      Your Luminary account is not linked to {connectableIntegrationNames}.
      Please link your account to enable linking this client to{' '}
      {connectableIntegrationNames}.
    </ConfirmationModal>
  );
}
